<template>
  <div
    class="flex max-h-6 items-center justify-center gap-2 rounded-full bg-p-500 px-1 py-2 text-xs font-semibold"
  >
    <ChevronDown class="h-5 w-5 rotate-90" />
    <span>swipe</span>
    <ChevronDown class="h-5 w-5 -rotate-90" />
  </div>
</template>

<script setup lang="ts">
import ChevronDown from '~/assets/icons/ChevronDown.svg'
</script>
